// getNumbericVal will return the numeric value if valid number string else will return the default value passed
export const getNumericVal = (val: string | null, defaultVal: number) => {
  if (val === null || isNaN(parseInt(val))) return defaultVal;
  return parseInt(val);
};
